export const getUserData = ({ user }) => user.user;
export const getUserDataError = ({ user }) => user.errors;
export const getOpenInfoSelector = ({ user }) => user.openInfo;
export const getOpenSidebarSelector = ({ user }) => user.openSidebar;
